export enum ComandoEnum {
    LIGAR = 'ligar',
    DESLIGAR = 'desligar',
}
